<!--
 * @Author: Victor
 * @Date: 2023-12-27 19:08:08
 * @LastEditors: Merlin
 * @LastEditTime: 2025-06-20 14:59:04
 * @Description:
    必須傳入共用方法 useAutoBetToolKit
    點擊只負責 觸發自動下注 自動下注工具包可去 useAutoBetToolKit 看下使用方式
    当前组件名：<ButtonBetAuto
-->
<template>
    <Button
        @click="onAutoClick"
        :class="[...aClassName]"
        mode="primary"
        :disabled="bFinalDiabled"
        :dismark="bFinalDiabled"
        v-click-and-rest="400"
        class="h-full text-center !rounded-[7px] justify-center text-white w-[50%] sm:w-[30%]"
    >
        <div class="flex items-center justify-center gap-[4px]">
            <span>
                {{ $t(isSubmiting ? 'BetStop' : 'BetStart') }}
            </span>
            <CasinoWidgetRunningIcon
                v-if="isSubmiting"
                class="mr-[-3px]"
            >
            </CasinoWidgetRunningIcon>
        </div>
        <!-- ↓ 自动模式剩余局数量 -->
        <div >
            {{ autoOption.sRoundsRest }}
        </div>
    </Button>
</template>

<script lang="ts" setup>
import { useAutoBetToolKit } from '~/common/js/bettingToolkit/auto';
import { useAutoOptionStore } from '~/stores/cansino/autoOption';
import { useJoinStateStore } from '~/stores/cansino/joinState';
import betHelper from '~/common/js/betHelper';
import type { PropType } from 'nuxt/dist/app/compat/capi';

const autoOption = useAutoOptionStore();
const joinStateStore = useJoinStateStore();
const { number } = storeToRefs(autoOption);

const props = defineProps({
    autoBetToolKit: {
        type: Object as PropType<ReturnType<typeof useAutoBetToolKit>>,
    },
    isSubmiting: {
        type: Boolean,
        required: true,
    },
    disabled: {
        type: Boolean,
        default: false,
    },
});

const GameStatus = { // 游戏状态库 
    default: 'default',
    autoRunning: 'autoRunning',
    closing: 'closing',
    closed: 'closed',
}

const aClassName = computed(()=>{
    const aResult = [];
    if (autoOption.isAutoBetting) aResult.push('button-red')
    return aResult;
});

const sGameStauts = ref(GameStatus.default);

const onAutoClick = async () => {
    const isSubmiting = props.isSubmiting;
    const sGame = joinStateStore.gameName;
    console.log(`游戏：${sGame} props.isSubmiting =`, isSubmiting, isSubmiting ? '将关停' : '将启动'); 
    // ↓ 下注进行中，则立即终止下注 
    if (isSubmiting) {
        console.log('自动模式 closing');
        const t01 = Date.now();
        sGameStauts.value = GameStatus.closing; // 此举将触发按钮锁定 
        await props.autoBetToolKit.stopInfinity(true);
        await Sleep(300);
        console.log('自动模式 closed, consumed', Date.now() - t01, 'ms gap');
        sGameStauts.value = GameStatus.closed;
        return;
    }
    // 停止中，则在验证后开始下注
    if (betHelper.betableCheck()){
        sGameStauts.value = GameStatus.autoRunning;
        props.autoBetToolKit.startInfinity();
    }
};

// 下注按钮禁用状态 
const bFinalDiabled = computed(()=>{
    let bResult = false;
    if (sGameStauts.value == GameStatus.closing){
        // ↓ 正在关闭中，100% 禁用。目前没发现例外  
        bResult = true; 
    }else{
        // ↓ 否则接受传参控制 
        bResult = !!props.disabled; 
    }
    console.log('是否禁用自动下注按钮', bResult, '👈'); 
    return bResult;
});

</script>


<style lang="scss" scoped>

</style>